import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './QQInsightsFooterActions.module.css';
import MLButton from '../../../../../../components/MLButton';
import MLIcon from '../../../../../components/MLIcon/MLIcon';
import { INSIGHTS_MENU,
  WIDGET_TYPE_TOP_LO_BAR_CHART,
  WIDGET_TYPE_TOP_ASSIGNMENTS_BAR_CHART,
  WIDGET_TYPE_TOP_EXTERNAL_LO_BAR_CHART,
  WIDGET_TYPE_ASSIGNMENT_SCORE_HISTOGRAM_CHART,
  WIDGET_TYPE_TIME_ATTEMPTS_CHART,
  WIDGET_TYPE_TIME_SCORE_CHART,
  WIDGET_TYPE_COMPLETED_ASSIGNMENT,
 } from '../../../../constants';
import useLocalStorage from '../../../InsightsTabs/hooks/useLocalStorage';
import { useLaunchActivity } from '../../../../contexts/LaunchContext';

const { ASSIGNMENT_PERFORMANCE } = INSIGHTS_MENU;

const VIEW_DETAILS_TEST_ID_BY_WIDGET_TYPE = {
  [WIDGET_TYPE_TOP_LO_BAR_CHART]: 'InsightsLearningObjectives_ViewDetails_btn',
  [WIDGET_TYPE_TOP_ASSIGNMENTS_BAR_CHART]: 'InsightsTopAssignments_ViewDetails_btn',
  [WIDGET_TYPE_TOP_EXTERNAL_LO_BAR_CHART]: 'InsightsAlternateLOs_ViewDetails_btn',
  };

  const GO_TO_ASSIGNMENT_TEST_ID_BY_WIDGET_TYPE = {
  [WIDGET_TYPE_ASSIGNMENT_SCORE_HISTOGRAM_CHART]: 'Insights_ScoreDistribution_GoToAssignment_btn',
  [WIDGET_TYPE_TIME_ATTEMPTS_CHART]: 'Insights_AttemptsVsTime_GoToAssignment_btn',
  [WIDGET_TYPE_TIME_SCORE_CHART]: 'Insights_ScoresVsTime_GoToAssignment_btn',
  [WIDGET_TYPE_COMPLETED_ASSIGNMENT]: 'Insights_Completions_GoToAssignment_btn',
  };

function QQinsightsFooterActions({
  onInsightDetails,
  showDetails,
  isSRLWidget,
  widgetType,
  isCheckedReadingTabData,
  assignment,
  courseShortId,
  productModelId,
  aiSummaryEnabled,
  isSRLSummaryWidget,
}) {
  const [insightsTab] = useLocalStorage(
    'selected_insights_tab',
    ASSIGNMENT_PERFORMANCE
  );
  const launchActivity = useLaunchActivity();
  const handleGoToAssignment = () => {
    if (assignment) {
      launchActivity(
        assignment,
        courseShortId,
        productModelId,
        isCheckedReadingTabData
      );
    }
  };

  const isGoToAssignmentButtonVisible = insightsTab === ASSIGNMENT_PERFORMANCE;

  const currentTime = new Date();
  const dueDate = assignment?.assignment_due_at
    ? new Date(assignment.assignment_due_at)
    : null;
  const isPastDue = dueDate ? currentTime > dueDate : false;
  const showSummaryCallOut =
    aiSummaryEnabled && isSRLSummaryWidget && isPastDue;

  return (
    <div className={styles.container}>
      {isGoToAssignmentButtonVisible && (
        <MLButton
          testId={GO_TO_ASSIGNMENT_TEST_ID_BY_WIDGET_TYPE[widgetType] || 
            `go-to-assignment`}
          className={styles.goToAssignmentButton}
          onClick={handleGoToAssignment}
          btnType="secondary"
          aria-label="Go to the assignment"
        >
          Go To Assignment
        </MLButton>
      )}
      {!isGoToAssignmentButtonVisible && showDetails && (
        <div
          className={classnames(styles.viewDetailsButtonContainer, {
            [styles.summaryCallOutContainer]: showSummaryCallOut,
          })}
        >
          {showSummaryCallOut && (
            <div className={styles.summaryCallOut}>
              <span>
                <MLIcon type="sparkle" className={styles.sparkleIcon} /> Summary
                Available
              </span>
              <MLIcon type="arrow_right" className={styles.arrowIcon} />
            </div>
          )}
          <MLButton
            testId={VIEW_DETAILS_TEST_ID_BY_WIDGET_TYPE[widgetType] || 
            `view-${isSRLWidget ? 'responses': 'details'}`}
            className={styles.viewResponsesButton}
            onClick={onInsightDetails}
            btnType="secondary"
            btnText={isSRLWidget ? 'View Responses' : 'View Details'}
          />
        </div>
      )}
    </div>
  );
}

QQinsightsFooterActions.propTypes = {
  onInsightDetails: PropTypes.func,
  showDetails: PropTypes.bool,
  isSRLWidget: PropTypes.bool,
  widgetType: PropTypes.string,
  isCheckedReadingTabData: PropTypes.bool,
  assignment: PropTypes.object,
  courseShortId: PropTypes.string,
  productModelId: PropTypes.number,
  aiSummaryEnabled: PropTypes.bool,
  isSRLSummaryWidget: PropTypes.bool,
};

export default QQinsightsFooterActions;
